import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { machineOperatorSideBarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={machineOperatorSideBarItems} />
}

export default Navbar;